module.exports = "/assets/images/bottom-arrow-small_3b7b64.svg";